// Resolve the API base. Prefer REACT_APP_BACKEND_URL, but if the page is served from a
// different origin (e.g. the eventual custom domain www.rollconerp.com) fall back to the
// page's own origin so production never accidentally calls the preview API, and cookies
// stay first-party. The resulting base is always ABSOLUTE (used directly in CSV exports).
function resolveApiBase() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  const pageOrigin = (typeof window !== "undefined" && window.location) ? window.location.origin : "";
  try {
    const envOrigin = new URL(envUrl).origin;
    if (pageOrigin && pageOrigin !== envOrigin) {
      console.warn("[Rollcon] Page origin differs from REACT_APP_BACKEND_URL; using same-origin API to avoid cross-origin/preview calls.");
      return pageOrigin + "/api";
    }
    return envOrigin + "/api";
  } catch (e) {
    return pageOrigin + "/api";
  }
}

export const API = resolveApiBase();

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export async function startSignIn() {
  // Mint a browser-bound OAuth state nonce (httpOnly cookie) before leaving for the provider.
  const resp = await fetch(`${API}/auth/start`, { credentials: "include" });
  const { state } = await resp.json();
  const redirectUrl = window.location.origin + "/erp?state=" + encodeURIComponent(state);
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

// Resolves only when the server confirms the session was cleared. Throws otherwise so the
// caller can show a retryable failure and keep the user in place (session may still be valid).
export async function signOut() {
  const resp = await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" });
  if (!resp.ok) throw new Error("Sign out was not confirmed by the server.");
  window.location.href = "/";
}
